import SettingsIcon from "@mui/icons-material/Settings";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import useSunoDialer from "../use-suno-dialer.hook";
export default function VoiceSettingsButton() {
  const { handleToggleShowSettings } = useSunoDialer();
  return (
    <Tooltip title="Voice settings" disableInteractive>
      <IconButton
        size="small"
        sx={{
          p: 0,
          transform: "scale(0.8)",

          color: "white",
        }}
        onClick={(event) => {
          event.stopPropagation();
          handleToggleShowSettings();
        }}
      >
        <SettingsIcon />
      </IconButton>
    </Tooltip>
  );
}
